import React from 'react'

import './Checkbox.css'

export default function Checkbox({ label, id, isChecked, handleChange }) {

    return (<div className='checkbox'>
        <div className='checkbox-label'>{label}</div>
        <div><input className='checkbox-input' type="checkbox" name={id} checked={isChecked} onChange={handleChange} /></div>
    </div>)
}